// START Open Requre.JS wrapper
define([
	'jquery',
	'pubsub',
	'cycle',
	'shared.lazyload',
	'shared.main.screen'
], function($,pubsub,cycle,lazyload,screenSize) {
// END Open Require.JS wrapper


/****
 * Dynamic Media Banner provides carousel with support for image maps.
 ***/

	var PLUGIN_IDENTIFIER = "carouselContainer";
	var carouselContainer = function( element, options ) {
		this.element = element;
		this.options = options;
		this.$carousel = $('.carousel',this.element);
		this.defaults = {
			// timeout: 5000,
			slides: "> .slide",
			pauseOnHover: true,
			fx: "scrollHorz",
			prev: $(this.element).find('.cycle-prev'),
			next: $(this.element).find('.cycle-next'),
			pager: $(this.element).find('.cycle-pager'),
			'pagerTemplate': '<span></span>',
			swipe: true,
			maxZ: 50,
			lazyLoad: false,
			hideNonActive: true
		};

		// This next line takes advantage of HTML5 data attributes
		// to support customization of the plugin on a per-element
		// basis. For example,
		// <section class='carousel-container' data-carousel-container-options='{"message":"Goodbye World!"}'></section>
		this.metadata = $(this.element).data('carousel-container-options');

		// set additional defaults for multi-slide view (when transition type is carousel)
		if (this.metadata.fx && this.metadata.fx == "carousel") {
			this.isMultislideLayout = true;
			this.defaults = $.extend({
				autoHeight: "calc",
				carouselFluid: true,
				displayCounts: [1,1,1], // Default to 1 for Small, Medium, and Large slide counts
				carouselVisible: 0 // default number of items to display onscreen at once is 0 so we can draw it responsively
			}, this.defaults);
		}
	};

	carouselContainer.prototype = {
		defaults: { },

		init : function () {
			console.log("Initializing Carousel Container for",$(this.element));
			var self = this;

			self.config = $.extend( {}, self.defaults, self.options, self.metadata );

			self.$element = $(self.element);

			self.$slides = self.$element.find('.slide');
			self.$liveregion = self.$element.find('.liveregion');
			self.livetext = self.$liveregion.data('live-text');

			// Initialize events
			self.events();

			// If multiple slides per page are enabled, set the number of visible slides per current breakpoint
			if(self.isMultislideLayout) {
				self.config.carouselVisible = self.calculateSize();
			}

			self._build();

			// Setup lazy loading when multi-slide view is not enabled
			if(!self.isMultislideLayout) {
				self._initLazyLoad();
			}
			// Initialize the carousel
			self.$carousel.cycle(self.config);

			return self;
		},


		/**
		 * Setup any event handling
		 **/
		events : function () {
			var self = this;

			// pause when focus enters carousel or carousel is clicked (cycle2 only supports pause on hover)
			self.$element.on('focusin click', function() {
				self.$carousel.cycle('pause');
			});

			// resume when focus leaves carousel
			self.$element.on('focusout', function() {
				self.$carousel.cycle('resume');
			});

			// trigger platform events
			self.platformEvents();

			// load layout-specific events
			if(self.isMultislideLayout) {
				self.multiSlideEvents();
			}
			else {
				self.singleSlideEvents();
			}
		},


		/**
		 * Translate native carousel events into platform pubsub events
		 **/
		platformEvents : function() {
			var self = this;

			// Triggered when the carousel is created
			self.$carousel.on( 'cycle-initialized', function( ev, opts ) {
				$.pubsub('publish', 'vfdp.aem.carouselcontainer.initialized', {"event":ev,"opts":opts});
			});

			// Triggered when a slide is added to the carousel and about to be displayed for the first time
			self.$carousel.on( 'cycle-slide-added', function( ev, opts, slideOpts, slide ) {
				$.pubsub('publish', 'vfdp.aem.carouselcontainer.slideAdded', {
					"event":ev,
					"opts":opts,
					"slideOpts":slideOpts,
					"slide":slide
				});
			});

			// Triggered immediately before a slide transition
			self.$carousel.on( 'cycle-before', function( ev, opts ) {
				$.pubsub('publish', 'vfdp.aem.carouselcontainer.slideBefore', {"event":ev,"opts":opts});
			});

			// Triggered when a slide transition is complete
			self.$carousel.on( 'cycle-after', function( ev, opts ) {
				$.pubsub('publish', 'vfdp.aem.carouselcontainer.slideAfter', {"event":ev,"opts":opts});
			});

			// Triggered when the next/prev buttons are clicked
			self.$carousel.on( 'cycle-next cycle-prev', function( ev, opts ) {
				$.pubsub('publish', 'vfdp.aem.carouselcontainer.' + ev.type, {"event":ev,"opts":opts});
				
				// update the liveregion for screenreaders
				self.$liveregion.text(self.livetext.replace("{0}", (opts.currSlide + 1)));
			});

			// Triggered when the carousel is paused (by hover or click)
			self.$carousel.on( 'cycle-paused', function( ev, opts ) {
				$.pubsub('publish', 'vfdp.aem.carouselcontainer.paused', {"event":ev,"opts":opts});
			});

			// Triggered when the carousel is resumed from a paused state
			self.$carousel.on( 'cycle-resumed', function( ev, opts ) {
				$.pubsub('publish', 'vfdp.aem.carouselcontainer.resumed', {"event":ev,"opts":opts});
			});
		},


		/**
		 * Events only needed for single-slide layout
		 **/
		singleSlideEvents : function() {
			var self = this;

			// Set the height of the carousel before cycle2 starts
			// This will prevent the jump while the JS renders the slideshow
			self.$carousel.one('cycle-bootstrap',function() {
				// Get the first slide and set the container to that height
				$(self.$carousel).height($('div:first-child', self.$carousel).outerHeight());
			});

			// After carousel initializes, go back to normal height behavior
			self.$carousel.one('cycle-post-initialize',function() {
				setTimeout(function(){
					$(self.$carousel).height('auto');
				}, 50);
			});

			// Make sure we don't have 0 height slides breaking layout since they were loaded initially hidden
			self.$carousel.on('cycle-before', function(ev,opts,outgoingSlideEl,incomingSlideEl,forwardFlag) {
				$(incomingSlideEl).css("display","table"); // Restores clearfix to slide so it has a height
				main.update(); // apply equalizer
			});

			// when the view changes ensure inactive slides are not focusable and hidden from screen readers
			self.$element.on('cycle-update-view', function(ev, opts, slideOpts, curSlide) {
				// inactivate hidden slides
				self.$slides.addClass('inactive').attr({'aria-hidden': true});

				// activate visible slides
				$(curSlide).removeClass('inactive').attr({'aria-hidden': false});
			});
		},


		/**
		 * Events only needed for multiple-slide layout
		 **/
		multiSlideEvents : function() {
			var self = this;

			// When carousel initializes ensure inactive slides are not accessible
			self.$carousel.on('cycle-post-initialize',function() {
				self.$element.find('.slide').addClass('inactive').attr({'aria-hidden': true});
			});

			// when the view changes ensure inactive slides are not focusable and hidden from screen readers
			self.$element.on('cycle-update-view', function(ev, opts, slideOpts, curSlide) {
				// inactivate hidden slides
				self.$element.find('.slide').addClass('inactive').attr({'aria-hidden': true});

				// activate visible slides
				var visibleSlides = $(curSlide).nextAll('.slide').addBack().slice(0,opts.carouselVisible);
				visibleSlides.removeClass('inactive').attr({'aria-hidden': false});
			});

			// When multiple slides per page are enabled rebuil the carousel whenever
			// user switches breakpoints so the number of slides can be recalculated
			$.pubsub('subscribe', 'window.resize.breakpoint', function (event, data) {
				// Determine the new carousel count
				self.config.carouselVisible = self.calculateSize(data.now);
				// Rebuild the carousel
				self.$carousel.cycle("destroy").cycle(self.config);
			});
		},


		/**
		 * Setup Lazy-loading behavior
		 **/
		_initLazyLoad: function() {
			var self = this;

			switch(self.config.lazyLoad) {
				case "prefetch" :
					// use the first slide to set the carousel height because images in the other slides have not loaded yet
					self.config.autoHeight = 0;

					// After a slide is transitioned, start loading images for the next slide
					self.$element.on('cycle-after', function(ev,opts,outgoingSlideEl,incomingSlideEl,forwardFlag) {
						var nextSlide = $(incomingSlideEl).next('.slide');
						$('.lazy-load',nextSlide).lazyload().removeClass('lazy-load');
					});

					// 1st and 2nd slide won't prefetch since carousel init doesn't trigger cycle-after for the first slide displayed
					self.$element.on('cycle-pre-initialize', function(ev,opts) {
						$('.lazy-load',$(opts.slides.slice(0,1))).lazyload().removeClass('lazy-load');
					});
					break;

				case "oninit" :
					// Start loading images for all slides immediately once the carousel is initialized
					self.$element.on('cycle-pre-initialize', function(ev,opts) {
						$('.lazy-load',$(opts.slides)).lazyload().removeClass('lazy-load');
					});
					break;

				case "ondemand" :
					// Load images only when a slide starts displaying
					// mostly same use-case as when uses jump to a specific slide

					// use the first slide to set the carousel height because images in the other slides have not loaded yet
					self.config.autoHeight = 0;

					// 1st slide won't prefetch since carousel init doesn't trigger cycle-before for the first slide displayed
					self.$element.on('cycle-pre-initialize', function(ev,opts) {
						$('.lazy-load',opts.slides[0]).lazyload().removeClass('lazy-load');
					});
					break;

				default :
					// No lazy loading configured. Don't waste time setting up events
					return self;
			}
			// First slide doesn't trigger any of the previous events, so let's make sure it gets loaded

			// In all cases if users jump to an unloaded slide, we need to make sure the images load
			self.$element.on('cycle-before', function(ev,opts,outgoingSlideEl,incomingSlideEl,forwardFlag) {
				$('.lazy-load',incomingSlideEl).lazyload().removeClass('lazy-load');
			});

			return self;
		},


		/**
		 * Calculates how many items to display when multiple slides per page are enabled, based on the current screen size
		 **/
		calculateSize : function(screensize) {
			var itemsVisible = 0;
			screensize = typeof(screensize) !== 'undefined' ? screensize : screenSize.size();

			switch(screensize) {
				case "small" :
					itemsVisible = this.config.displayCounts[0];
					break;
				case "medium" :
					itemsVisible = this.config.displayCounts[1];
					break;
				default : // large, xlarge, or no size detected
					itemsVisible = this.config.displayCounts[2];
					break;
			}

			return itemsVisible;
		},


		/**
		 * Modify the DOM to support layout
		 **/
		_build : function() {

		},
	};

	carouselContainer.defaults = carouselContainer.prototype.defaults;

	// prevent duplicate instantiation
	$.fn.carouselContainer = function(options) {
		return this.each(function() {
			var instance = $(this).data(PLUGIN_IDENTIFIER);
			if(!instance) {
				instance = new carouselContainer(this, options).init();
				$(this).data(PLUGIN_IDENTIFIER,instance);
			}
		});
	};


// START close Require.JS wrapper		
		}
);
// END close Require.JS wrapper
